function PowerTree({ id = "", name, tree }) {
  this.id = id;
  const { root, branch = [], deep = 1, pcbIndex = [], logs = [], whatIf = false, whatIfData = [], paths = {}, mainPCB } = tree;
  this.tree = {
    key: name,
    root,
    branch,
    name,
    deep,
    pcbIndex,
    logs,
    whatIf,
    whatIfData,
    paths,
    mainPCB
  };
}
// Instead of v1, remove groundNets, remove groundComps and pins, add paths to keep power tree paths

function PowerTreeItem(props) {
  const {
    gnds = [], id, ids = [], isGnd, name, part, number, deep,
    next = [], prev = [], pcbKey, pins, rootId, type,
    resistance, voltage, load, vMin, vMax, resistances,
    broComp
  } = props;
  this.gnds = gnds;
  this.id = id;
  this.ids = ids;
  this.isGnd = isGnd;
  this.name = name;
  this.part = part;
  this.number = number;
  this.deep = deep;
  this.next = next;
  this.prev = prev;
  this.pcbKey = pcbKey;
  this.pins = pins;
  this.rootId = rootId;
  this.type = type;
  this.resistance = resistance;
  this.voltage = voltage;
  this.load = load;
  this.vMin = vMin;
  this.vMax = vMax;
  this.resistances = resistances;
  this.broComp = broComp;
}

export {
  PowerTree,
  PowerTreeItem
}
